import React from 'react';
import styled from 'styled-components';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import moment from 'moment';

import { updateWorkingHours, fetchWorkingHours } from '../../redux/business';
import { ProfileSaveButton } from '../Common';
import { testWindow } from '../Wrappers/MainWindow';
import Frame from '../Wrappers/Frame';
import { Row, Col } from '../Grid';
import { TimePicker } from '../Offers/Create/DateAdapter';
import { Form, Field, FieldRenderProps } from 'react-final-form';
import { AnalyticsService } from '../../services/AnalyticsService';
import { Hour, Hours } from './WorkingHourTypes';

const daysShort = {
  sunday: 'SU',
  monday: 'M',
  tuesday: 'T',
  wednesday: 'W',
  thursday: 'TH',
  friday: 'F',
  saturday: 'SA',
};

const Name = styled(Col)`
  font-family: BrandonGrotesque-Regular;
  font-size: 18px;
  letter-spacing: 0.2px;
  line-height: 53px;
  color: #555555;
`;

const Divider = styled.hr`
  margin-top: 7px;
  margin-bottom: 7px;
`;

const SpacerCol = styled(Col)`
  text-align: center;
  line-height: 50px;
  font-size: 20px;
`;

class TimeItem extends React.Component<{ time: string; onChange: Function }, { show: boolean }> {
  state = { show: false };

  render() {
    document.title = 'Edit Hours • Neoncoat Brands Tool';
    const current = moment(this.props.time, 'HH:mm').format('h:mm A');

    return (
      <Col size="0 0 100px">
        <input
          value={current !== 'Invalid date' ? current : ''}
          style={{ width: '120px' }}
          onClick={() => this.setState({ show: true })}
        />
        <TimePicker
          show={this.state.show}
          hour={moment(this.props.time, 'HH:mm').format('HH')}
          minute={moment(this.props.time, 'HH:mm').format('mm')}
          onChange={(t) => {
            this.props.onChange(t);
            this.setState({ show: false });
          }}
        />
      </Col>
    );
  }
}

const PickerAdapter = (props: FieldRenderProps<any, HTMLElement>) => {
  const {
    input: { onChange, value },
  } = props;
  const addTime = () => onChange(value.concat([{ open: '', close: '' }]));
  const removeTime = (index: number) => {
    const tmp = [...value];
    tmp.splice(index, 1);
    onChange(tmp);
  };
  const changeTime = (index: number, type: string, time: any) => {
    const tmp = [...value];
    tmp[index][type] = `${moment(time.hour, 'H').format('HH')}:${time.minute}`;
    onChange(tmp);
  };

  const add = (
    <Col size="0 0 50px">
      <svg
        width="20"
        height="20"
        style={{ marginTop: '15px', cursor: 'pointer' }}
        viewBox="0 0 1792 1792"
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => addTime()}
        fill="#555555"
      >
        <path d="M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z" />
      </svg>
    </Col>
  );
  const remove = (index: number) => (
    <Col size="0 0 50px">
      <svg
        width="20"
        height="20"
        viewBox="0 0 1792 1792"
        color="red"
        style={{ marginLeft: '10px', cursor: 'pointer', marginTop: '13px' }}
        xmlns="http://www.w3.org/2000/svg"
        fill="#555555"
        onClick={() => removeTime(index)}
      >
        <path d="M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z" />
      </svg>
    </Col>
  );
  return (
    <>
      {add}
      <Col size="1">
        {value.map((item: Hour, index: number) => (
          <Row key={index} style={index !== 0 ? { marginTop: '5px' } : {}}>
            <TimeItem time={item.open} onChange={(time: any) => changeTime(index, 'open', time)} />
            <SpacerCol size="0 0 50px">-</SpacerCol>
            <TimeItem
              time={item.close}
              onChange={(time: any) => changeTime(index, 'close', time)}
            />
            {remove(index)}
          </Row>
        ))}
      </Col>
    </>
  );
};

interface Props {
  businessId: string;
  save: Function;
  hours: Hours;
  load: Function;
}
class WorkingHoursEditor extends React.Component<Props, any> {
  saveTime(state) {
    AnalyticsService.track('Save Business hours', {});
    this.props.save({ working_hours: JSON.stringify(state) }, this.props.businessId);
  }

  componentDidMount() {
    if (!this.props.hours) {
      this.props.load(this.props.businessId);
    }
  }

  render() {
    return (
      <Row>
        <Col size="9">
          <Form
            onSubmit={(state) => this.saveTime(state)}
            initialValues={this.props.hours}
            render={({ handleSubmit }) => (
              <Frame
                title="Business Hours"
                right={<ProfileSaveButton onClick={handleSubmit}>SAVE</ProfileSaveButton>}
              >
                {Object.keys(daysShort).map((day) => (
                  <>
                    <Row key={day}>
                      <Name size="0 0 120px">{day.capitalize()}</Name>
                      <Field name={day} render={(props) => <PickerAdapter {...props} />} />
                    </Row>
                    <Divider />
                  </>
                ))}
              </Frame>
            )}
          />
        </Col>
        <Col size="3" />
      </Row>
    );
  }
}

function mapStateToProps(state: StoreState) {
  return {
    hours: state.business.working_hours,
    businessId: state.business.business_id,
  };
}

const mapDispatchToProps = {
  edit: () => push('/profile/hours'),
  load: (id) => fetchWorkingHours(id),
  save: (hours, businessId) => updateWorkingHours(hours, businessId),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(testWindow(WorkingHoursEditor, 'profile'));
